import { Paper, Stack } from "@mui/material";
import { EnergyAnalysisEnergyInput } from "features/energy-analysis-dashboard/components/EnergyAnalysisEnergyInput";
import { useCrremEnergyInputUpload } from "features/energy-analysis-dashboard/hooks/useCrremEnergyInputUpload";
import { useTranslation } from "react-i18next";
import { cn } from "utils/styling";

type CrremPathwayEmptyStateProps = {
  className?: string;
  projectId: string;
  title?: string;
};

export const CrremPathwayEmptyState = ({ className, projectId, title }: CrremPathwayEmptyStateProps) => {
  const { t } = useTranslation();
  const { downloadTemplate, isUploading, uploadFile } = useCrremEnergyInputUpload(projectId);
  return (
    <Paper className={cn("relative p-1", className)}>
      <Stack className="min-h-0 w-full flex-col items-stretch gap-4">
        {title ? <h2 className="font-ds-headline-lg text-left text-lds-foreground-heading-active">{title}</h2> : null}
        <EnergyAnalysisEnergyInput
          disabled={isUploading}
          hint={String(t("BuildingProfile.energyAnalysis.noDataHint"))}
          isUploading={isUploading}
          onDownload={downloadTemplate}
          onUpload={uploadFile}
          title={String(t("BuildingProfile.energyAnalysis.noDataTitle"))}
        />
      </Stack>
    </Paper>
  );
};
